import {benAdminActionTypes} from "./actionTypes"

export function setBenAdminName(name) {
    return {
        type: benAdminActionTypes.SET_BEN_ADMIN_NAME,
        payload: name
    }
}

export function setBenAdminLastName(lastName) {
    return {
        type: benAdminActionTypes.SET_BEN_ADMIN_LAST_NAME,
        payload: lastName
    }
}

export function resetBenAdminData(){
    return {
        type: benAdminActionTypes.RESET_BEN_ADMIN_DATA,
        payload: {}
    }
}